import React from "react";
import cx from "classnames";
// import PropTypes from 'prop-types'
import { BreadcrumbStyled } from "./styled";
import { useNavigate } from "react-router-dom";
import { Icons } from "components";

const Breadcrumb = ({ theme_standard, home_page, secondary_page, data }) => {
  const customClass = cx({
    theme_standard: theme_standard,
  });

  const navigate = useNavigate();
  return (
    <BreadcrumbStyled className={customClass}>
      {data &&
        data.map((e, i) => (
          <div key={i} className="breadcrumb_item">
            <button
              className="home_page_button"
              onClick={() => e.path && navigate(e.path)}
            >
              {e.name}
            </button>
            {i < data.length - 1 && (
              <span>
                <Icons.ArrowRight color="#495057" width={8} height={8} />
              </span>
            )}
            {/* <button className="secondary_page_button">{e.name}</button> */}
          </div>
        ))}
      {/* <button className="home_page_button">{home_page}</button>
      <Icons.ArrowRight color="#495057" width={8} height={8} />
      <button className="secondary_page_button">{secondary_page}</button> */}
    </BreadcrumbStyled>
  );
};

Breadcrumb.propTypes = {};

export default Breadcrumb;
